"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "dropdown dropdown-right mx-10" };
const _hoisted_2 = {
    key: 0,
    class: "circle-container comment-number-badge notification-alert-icon"
};
const _hoisted_3 = { class: "menu menu-width notification-dropdown-container" };
const _hoisted_4 = {
    key: 1,
    class: "text-center",
    width: "100%"
};
const _hoisted_5 = { class: "text-gray" };
const _hoisted_6 = { key: 2 };
const _hoisted_7 = { class: "notification-header" };
const _hoisted_8 = ["data-tooltip"];
const _hoisted_9 = { class: "flex-center flex-gap" };
const _hoisted_10 = { class: "notification-title" };
const _hoisted_11 = { class: "circle-container comment-number-badge" };
const vue_3 = require("vue");
const NotificationCard_vue_1 = __importDefault(require("./components/NotificationCard.vue"));
const notificationStore_1 = require("../../../store/v1/notificationStore");
const notificationType_1 = require("./type/notificationType");
const notificationsRequest_1 = require("./requests/notificationsRequest");
const dashboard_1 = require("../../../js/dashboard");
exports.default = (0, vue_1.defineComponent)({
    __name: 'NotificationDropdown',
    props: {
        branchId: {
            type: Number,
        },
        userId: {
            type: Number,
        },
        hasBoardPermission: {
            type: Boolean,
            required: true,
        },
        hasSummaryPermission: {
            type: Boolean,
            required: true,
        },
        goToSummary: {
            type: Boolean,
            required: true,
        },
        viewedActivityStr: {
            type: String,
            required: true,
        }
    },
    setup(__props) {
        const props = __props;
        const notificationStore = (0, vue_3.ref)(new notificationStore_1.NotificationStore());
        const isLoading = (0, vue_3.ref)(false);
        // Methods
        async function fetchNotifications() {
            if (!props.branchId || !props.userId) {
                return;
            }
            isLoading.value = true;
            try {
                if (props.hasBoardPermission) {
                    const boardPayload = {
                        from: props.viewedActivityStr,
                        notificationStore: notificationStore,
                    };
                    await (0, notificationsRequest_1.getBoardNotifications)(props.userId, props.branchId, boardPayload);
                }
                const slotPayload = {
                    from: props.viewedActivityStr,
                    hasSummaryPermission: props.hasSummaryPermission,
                    notificationStore: notificationStore,
                };
                await (0, notificationsRequest_1.getSlotNotification)(props.userId, props.branchId, slotPayload);
            }
            finally {
                isLoading.value = false;
            }
        }
        async function markAsRead(notificationId, type) {
            try {
                const urlType = type === notificationType_1.NotificationType.BoardNotification ? `board/notifications?postID` : `summary/notifications?slotLogID`;
                const url = `/dashboard/${props.userId}/${urlType}=${notificationId}&c=${props.branchId}`;
                const response = await fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                });
                if (!response.ok) {
                    throw new Error(`Failed to fetch summary notifications`);
                }
                notificationStore.value.delete(notificationId);
                (0, dashboard_1.updateBadge)(type);
            }
            catch (err) {
                alert(err);
            }
        }
        async function markAllAsRead() {
            await fetch(`/dashboard/${props.userId}/activity/ack_all?c=${props.branchId}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
            });
            notificationStore.value.deleteAll();
            (0, dashboard_1.removeBadge)();
        }
        // Computed Properties
        const notifications = (0, vue_3.computed)(() => {
            return notificationStore.value.query().sort((lhs, rhs) => rhs.time - lhs.time);
        });
        const hasNotifications = (0, vue_3.computed)(() => {
            return notifications.value.length;
        });
        const loadingClass = (0, vue_3.computed)(() => {
            return isLoading.value ? 'loading' : '';
        });
        (0, vue_3.onMounted)(async () => {
            await fetchNotifications();
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (hasNotifications.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("small", _hoisted_2, (0, vue_2.toDisplayString)(hasNotifications.value), 1 /* TEXT */))
                    : (0, vue_2.createCommentVNode)("v-if", true),
                _cache[1] || (_cache[1] = (0, vue_2.createElementVNode)("i", {
                    class: "zmdi zmdi-hc-lg zmdi-notifications-none dropdown-toggle c-hand",
                    tabindex: "0"
                }, null, -1 /* CACHED */)),
                (0, vue_2.createElementVNode)("div", _hoisted_3, [
                    (isLoading.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                            key: 0,
                            class: (0, vue_2.normalizeClass)(loadingClass.value)
                        }, null, 2 /* CLASS */))
                        : (!hasNotifications.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_4, [
                                (0, vue_2.createElementVNode)("em", _hoisted_5, (0, vue_2.toDisplayString)(_ctx.$t('notif.all_read')), 1 /* TEXT */)
                            ]))
                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_6, [
                                (0, vue_2.createElementVNode)("div", _hoisted_7, [
                                    (0, vue_2.createElementVNode)("button", {
                                        class: "btn btn-lg btn-clear tooltip tooltip-left mark-all-read-btn mr-2",
                                        "data-tooltip": _ctx.$t('notif.mark_all_read_tooltip'),
                                        onClick: markAllAsRead
                                    }, null, 8 /* PROPS */, _hoisted_8),
                                    (0, vue_2.createElementVNode)("div", _hoisted_9, [
                                        (0, vue_2.createElementVNode)("h6", _hoisted_10, (0, vue_2.toDisplayString)(_ctx.$t('notif.title')), 1 /* TEXT */),
                                        (0, vue_2.createElementVNode)("small", _hoisted_11, (0, vue_2.toDisplayString)(hasNotifications.value), 1 /* TEXT */)
                                    ])
                                ]),
                                _cache[0] || (_cache[0] = (0, vue_2.createElementVNode)("div", { class: "divider my-1" }, null, -1 /* CACHED */)),
                                (0, vue_2.createVNode)(vue_2.TransitionGroup, {
                                    name: "notification",
                                    tag: "div"
                                }, {
                                    default: (0, vue_2.withCtx)(() => [
                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(notifications.value, (notification) => {
                                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                key: notification.data.id,
                                                class: "notification-card"
                                            }, [
                                                (0, vue_2.createVNode)(NotificationCard_vue_1.default, {
                                                    branchId: __props.branchId,
                                                    userId: __props.userId,
                                                    notification: notification.data,
                                                    type: notification.type,
                                                    goToSummary: __props.goToSummary,
                                                    onMarkAsRead: markAsRead
                                                }, null, 8 /* PROPS */, ["branchId", "userId", "notification", "type", "goToSummary"])
                                            ]));
                                        }), 128 /* KEYED_FRAGMENT */))
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]))
                ])
            ]));
        };
    }
});
